import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../../../Components/Input'
import { makePostRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useMediaQuery, useTheme } from '@mui/material'

export default function CreateOperationForm({ fetchOperations, recette }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      Recette: recette.id,
    },
  })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePostRequest(urls.crudInstructionOperations, payload, {}, true)
    if (response.status === 201) {
      fetchOperations()
      handleClose()
    }
  }

  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Instruction</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Numero"
              label="Numero"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rows={4}
              multiline
              rules={{ required: true }}
              label="Instruction"
              name="Description"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
